export const initializeOrganizationScore = () => ({
  type: 'INITIALIZE_ORGANIZATION_SCORE',
});

export const fetchOrganizationScore = resp => ({
  type: 'FETCH_ORGANIZATION_SCORE',
  payload: resp,
});
